import { obterParametrosDaURL } from "../../../../functions";
import { 
    IRetornoPaginadoApi,
    ISolicitacaoSenha
} from "../../../../interfaces";
import { api } from "../../api";
import { ApiException } from "../../api-exception";

export interface IRetornoObterSolicitacoesDoUsuario extends IRetornoPaginadoApi {
  dado: ISolicitacaoSenha[];
}

export const ObterSolicitacoesDoUsuario = async (
  CurrentPage: number
): Promise<IRetornoObterSolicitacoesDoUsuario> => {
  const { token } = obterParametrosDaURL();

  try {
    const { data } = await api.get<IRetornoObterSolicitacoesDoUsuario>(
      `/solicitacaosenhaporusuario`,
      { params: { token, CurrentPage, Limit: 10 } }
    );

    return data;
  } catch (erro) {
    throw new ApiException(erro, "Erro ao buscar solicitações do usuário");
  }
};